import type { ReactElement } from 'react';

/**
 * Tabs: one of a few views of the same page, the chosen one underlined.
 *
 * ⚠ Tabs, not buttons or chips, whenever the choice is WHICH view — People
 * or Companies, which side of what is open. Vladimir, 2026-09-24: "People and
 * companies, shall be tabs, not buttons".
 */
export function Tabs<K extends string>({
  label,
  value,
  onChange,
  items,
}: {
  label: string;
  value: K;
  onChange: (key: K) => void;
  items: Array<{ key: K; label: string; count?: number }>;
}): ReactElement {
  return (
    <div className="subtabs" role="tablist" aria-label={label}>
      {items.map((item) => {
        const on = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={on}
            className={`tab ${on ? 'on' : ''}`}
            onClick={() => onChange(item.key)}
            style={{
              background: 'none',
              border: 0,
              borderBottom: on ? '2px solid var(--green)' : '2px solid transparent',
              cursor: 'pointer',
            }}
          >
            {item.label}
            {item.count !== undefined ? (
              <span className="mono" style={{ marginLeft: 6 }}>
                {item.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
